const files = require.context('./pages', true, /\.js$/)
let map = []
files.keys().map(path => {
	let key = path.replace(/(\/|\.|js)/g, '')
	let file = files(path).default || null
	map[key] = file
})
export default map
